export default [
  {
    path: '/goodslist',
    name: 'GoodsList',
    component: () => import('../views/product/goodslist.vue'),
    meta:{
      title:'产品列表'
    }
  },
]
